// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2FG2U","empty":"ModalGraph_empty__2VYDw"};